import Model from './Model';

class Services extends Model {
  getName() {
    return this.attrs.name;
  }

  setName(value) {
    this.attrs.name = value;
    return this;
  }

  getBusinessType() {
    return this.attrs.businessType;
  }

  setBusinessType(value) {
    this.attrs.businessType = value;
    return this;
  }

  getAddress() {
    return this.attrs.address;
  }

  setAddress(value) {
    this.attrs.address = value;
    return this;
  }

  getEmail() {
    return this.attrs.email;
  }

  setEmail(value) {
    this.attrs.email = value;
    return this;
  }

  getMobile() {
    return this.attrs.mobile;
  }

  getImageUpdatedAt() {
    return this.attrs.imageUpdatedAt;
  }

  setImageUpdatedAt(value) {
    this.attrs.imageUpdatedAt = value;
    return this;
  }

  setMobile(value) {
    this.attrs.mobile = value;
    return this;
  }

  getCurrency() {
    return this.attrs.currency;
  }

  setCurrency(value) {
    this.attrs.currency = value;
    return this;
  }

  getCountry() {
    return this.attrs.country;
  }

  setCountry(value) {
    this.attrs.country = value;
    return this;
  }

  getPortalName() {
    return this.attrs.portalName;
  }

  setPortalName(value) {
    this.attrs.portalName = value;
    return this;
  }

  getPortalUrl() {
    return this.attrs.portalUrl;
  }

  setPortalUrl(portalUrl) {
    this.attrs.portalUrl = portalUrl;
    return this;
  }

  getAddressLine1() {
    return this.attrs.addressLine1;
  }

  setAddressLine1(value) {
    this.attrs.addressLine1 = value;
    return this;
  }

  getAddressLine2() {
    return this.attrs.addressLine2;
  }

  setAddressLine2(value) {
    this.attrs.addressLine2 = value;
    return this;
  }

  getCity() {
    return this.attrs.city;
  }

  setCity(value) {
    this.attrs.city = value;
    return this;
  }

  getState() {
    return this.attrs.state;
  }

  setState(value) {
    this.attrs.state = value;
    return this;
  }

  getPincode() {
    return this.attrs.pincode;
  }

  setPincode(value) {
    this.attrs.pincode = value;
    return this;
  }

  getCustomerCareEmail() {
    return this.attrs.customerCareEmail;
  }

  setCustomerCareEmail(value) {
    this.attrs.customerCareEmail = value;
    return this;
  }

  getCustomerCareMobile() {
    return this.attrs.customerCareMobile;
  }

  setCustomerCareMobile(value) {
    this.attrs.customerCareMobile = value;
    return this;
  }

  getFaviconUrl() {
    return this.attrs.faviconUrl;
  }

  setFaviconUrl(value) {
    this.attrs.faviconUrl = value;
    return this;
  }

  getSecondaryAddress() {
    return this.attrs.secondaryAddress;
  }

  setSecondaryAddress(value) {
    this.attrs.secondaryAddress = value;
    return this;
  }
}

export default Services;
